import { writable } from 'svelte/store';
import { OAuthSession } from './oauth-session.js';

export const isLoggedIn = writable<boolean>(false);

export const initializeLoginState = async () => {
  isLoggedIn.set(await OAuthSession.isActive());
};
